import styled from "styled-components"
import { useOrbit3DStore } from "../state/orbit3DStore"

const LabelUI = () => {
  const activeLabel = useOrbit3DStore((s) => s.activeLabel)
  const setActiveLabel = useOrbit3DStore((s) => s.setActiveLabel)
  if (!activeLabel) return null
  // console.log(activeLabel.image.publicURL)
  return (
    <LabelUIWrapper
      style={{
        // backgroundImage: `url(${activeLabel.image.publicURL})`,
        backgroundImage: `url(/payload/galleryMedia/c5_SO1C_HERO_opt7_(4).jpg)`,
      }}
      onClick={() => {
        setActiveLabel(null)
      }}
    >
      <img src={activeLabel.image.publicURL} />

      {/* <img src="/payload/galleryMedia/c5_SO1C_HERO_opt7_(4).jpg" /> */}
      {/* {activeLabel.title} */}
    </LabelUIWrapper>
  )
}

export default LabelUI

const LabelUIWrapper = styled.div`
  position: absolute;
  z-index: 2;

  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4rem;

  background-color: var(--primary);

  padding: 2em;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
